import { render, staticRenderFns } from "./ChoiceFilter.vue?vue&type=template&id=0504ad80&scoped=true"
import script from "./ChoiceFilter.vue?vue&type=script&lang=ts"
export * from "./ChoiceFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0504ad80",
  null
  
)

export default component.exports